<template>
    <q-card v-bind="attrs">
        <q-card-section class="q-pt-none q-pl-sm" >
            <div v-if="data[spLayer]" id="turtlePane">
                <div class="row justify-end q-pa-sm print-hide">About these data <q-icon name="help_outline" class="q-pl-sm pointer" size="xs"  @click="dataConsiderations = !dataConsiderations"/></div>
                <div class="text-h6 q-mt-lg text-uppercase">Density<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['density'].model = !infoDialogs['density'].model" aria-label="Density data help"/></div>
                <div class="tab-container shadow-1">                
                    <q-tabs v-model="turtleTabs" class="shadow-1 q-ml-xs q-mr-xs">
                        <q-tab label="Annual Maximum"  @click="loadDataByID(spLayer, version), clearMap()" name="density"></q-tab>
                        <q-tab label="Monthly" @click="loadDataByID(spTimeLayer, version), clearMap()" name="time" ></q-tab>
                    </q-tabs>
                    <q-tab-panels dense v-model="turtleTabs" class="outlined">
                        <q-tab-panel name="density"  class="q-pa-xs">   
                            <q-card flat >
                                <!-- <div class="text-h5 q-pa-sm">{{ activeGroup.label }}</div> -->
                                <div class="row text-caption items-center q-mb-sm q-pl-sm q-mr-sm  map-descr-row">
                                    <div class="col-2 text-secondary">
                                        <span class="text-bold ">DATA ON THE MAP</span>:
                                    </div>
                                    <div class="col-6">
                                        <q-select
                                            :hide-bottom-space="true"
                                            dense
                                            class="secondary-dropdown q-ma-xs q-pa-xs"
                                            :options="spChoices"
                                            map-options
                                            v-model="activeSpCode"
                                            @update:model-value="rowClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                            hint="Select a species or click below"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-3">
                                        <q-select 
                                            :hide-bottom-space="true"
                                            dense 
                                            class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                            :options="layerTypes" 
                                            v-model="layerType"  
                                            @update:model-value="layerTypeChange"
                                            :hint="notSelectedTypes"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-1 justify-end items-end">
                                        <q-icon name="cancel" class="pointer text-end" size="sm" color="grey" @click="clearMap()"/>
                                    </div>  
                                </div>
 

                                <div class="row bar-header justify-center text-caption text-bold q-pr-sm">
                                    <div class="col-8 text-center">Species</div>
                                    <div class="col-4 text-right q-pl-lg">
                                        % Very High
                                        <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="infoDialogs['pHigh'].model = !infoDialogs['pHigh'].model" aria-label="High threshold help"/>
                                    </div>
                                </div>
                                <div class="bar-rows-container q-pr-sm"                                 
                                    tabindex="0" 
                                    role="region" 
                                    aria-label="Scrollable bar rows"
                                >
                                    <div v-for="barCat, i in barData" 
                                        @click="rowClick(barCat[0].spID, barCat[0].sp)"
                                        class="row pointer bar-row justify-center"
                                        :class="mapStyleInfo['attr'] === barCat[0].spID ? 'highlight' : ''">
                                        <div class="col-10">
                                            <!-- {{ barCat}} -->
                                            <StackedBar 
                                                :data="barCat" 
                                                :divName="barName(i)" 
                                                categoryProp="category" 
                                                barName="sp" 
                                                valueProp="value" 
                                                class="q-mt-none" 
                                                :xAxisTicks="false"
                                                :categoryColors="barColors"
                                                :topMargin="0"                                       
                                            />
                                        </div>

                                        <!-- the % high + very high is repeated for each sp obj in the array, so just take the first -->
                                        <div class="col-1 text-caption">{{ barCat[0].percHighVH }}</div>

                                    </div>
                                </div>
                            </q-card>             
                        </q-tab-panel>
                        <q-tab-panel name="time"  class="q-pa-xs" >                            
                            <div :style="{'min-height' : '25px'}" class="q-mt-sm" v-if="data[spTimeLayer]">
                                <div class="row text-caption items-center q-mb-sm q-pl-sm q-mr-sm  map-descr-row" >
                                    <div class="col-2 text-secondary">
                                        <span class="text-bold ">DATA ON THE MAP</span>:
                                    </div>
                                    <div class="col-4">

                                        <q-select
                                            :hide-bottom-space="true"
                                            dense
                                            class="secondary-dropdown q-ma-xs q-pa-xs"
                                            :options="spChoices"
                                            map-options
                                            v-model="activeSpCode"
                                            @update:model-value="tableCellClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                            hint="Select a species or click below"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-2">
                                        <q-select 
                                            :hide-bottom-space="true"
                                            dense 
                                            class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                            :options="months" 
                                            v-model="month"  
                                            @update:model-value="monthChange"
                                            hint="Month"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-3">
                                        <q-select 
                                            :hide-bottom-space="true"
                                            dense 
                                            class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                            :options="monthLayerTypes" 
                                            v-model="monthLayerType"  
                                            @update:model-value="tableCellClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                            :hint="notSelectedMonthTypes"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-1 justify-end items-end">
                                        <q-icon name="cancel" class="pointer text-end" size="sm" color="grey" @click="clearMap()"/>
                                    </div>     
                                </div>
                            </div>
                            
                            <div v-if="data[spTimeLayer]" class="time-table-container">
                                <Table 
                                    :version="version"
                                    :rows="turtleMonthData" 
                                    :columns="columns"
                                    title=""
                                    :expandRows="false"
                                    :mapStyle="true"
                                    :mapStops="stops['spp_95max']"
                                    :mapClassNames="legendColorStopNames"
                                    :cellColors="tableCellColors"
                                    :labelCells="false"
                                    :mapLayer=spTimeLayer
                                    :mapLegendTitles="turtleMonthLegendTitles"
                                    :selSp="activeSpCode ? activeSpCode : null"
                                    :selMonth="month ? month : null"
                                    @cellClick="tableClickEmitFunc"
                                    :dqStops=" dqStops['quality_4cls']"
                                    :dqClassNames="qualityClasses"
                                    :includeFilter="false"
                                    :flat="true"
                                    :hide-pagination="true"
                                ></Table>
                            </div> 
                            <div v-else class="row justify-center">
                                <q-spinner size="lg"></q-spinner>
                            </div>
                        </q-tab-panel>
                    </q-tab-panels>
                </div>
                <div class="row text-center justify-center q-mt-md q-mb-sm">
                    <div class="col-2" :style="{'background-color' : barColors['Very High'], 'color' :'white'}">Very High<br/>(>95)</div>
                    <div class="col-2" :style="{'background-color' : barColors['High']}">High<br/>(>90)</div>
                    <div class="col-2" :style="{'background-color' : barColors['Medium']}">Medium<br/>(>75)</div>
                    <div class="col-2" :style="{'background-color' : barColors['Low']}">Low<br/>(>0)</div>
                    <div class="col-2" :style="{'background-color' : barColors['No Data']}">No Data</div>
                </div>
            </div>
            <div v-else class="row justify-center">
                <q-spinner size="lg"></q-spinner>
            </div>
        </q-card-section>
    </q-card>
    <div v-for="(infoObj, name) in infoDialogs" :key="name" >
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
    <template>
        <q-dialog v-model="dataConsiderations">
            <q-card>
            <q-card-section>
                <SpeciesDataConsiderations groupsToShow="turtles" />
            </q-card-section>
            <q-card-actions align="right">
                <q-btn flat label="OK" color="primary" @click="dataConsiderations = false" />
            </q-card-actions>
            </q-card>
        </q-dialog>
    </template>
</template>
<script setup lang="ts">
import { toRefs, ref, onMounted, onUnmounted, computed, useAttrs } from "vue";
import { QTableColumn } from 'quasar';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { stops, dqStops } from "../assets/ColorStops.json"
import Dial from "./Dial.vue";
import StackedBar from "./StackedBar.vue";
import Table from "./Table.vue";
import InfoDialog from "./InfoDialog.vue";
import SpeciesDataConsiderations from "./SpeciesDataConsiderations.vue";
import { TurtleGroups } from "../assets/TurtleGroups.json"

import { AllCodes } from "../assets/SppCodesToNames.json"
const {  processDialData, processStackedBarData, processMonthData, styleMap, setLegend, mapStyleInfo, clearMapStyle, activeLayerID, setDataQuality, loadDataByID, processedData } = useMapItems()
const {  arrayFindObjectByProp } = useHelpers();
const attrs = useAttrs();

const props = defineProps({
    data: { type: Object },
    version: {type: Number},
    ecoregion: {type: String},
})

const {  data, version, ecoregion } = toRefs(props)


const barData = computed(() =>{
    const percHVHVals = [95,] // values that are used to calculate the % high & very high abundance
    const barData = processStackedBarData(version, data, spLayer, activeGroup, TurtleGroups, AllCodes, barCategories, barSortOrder, percHVHVals)
    return barData
   
})

const turtleMonthData=  computed(() =>{
    const sortOrder = getSpIDs(barData.value)
    const monthData = processMonthData(spTimeLayer, version, activeGroup, data, TurtleGroups, AllCodes, sortOrder)
    return monthData
})


const barSortOrder = ["Very High", "High", "Medium", "Low",  "No Data"]
const barCategories = {
        "-9" : "No Data",
        "0" : "Low",
        "75" : "Medium",
        "90" : "High",
        "95" : "Very High"
}

const activeGroup = ref({value:"all", label: "All Turtles"})

// if spLayer is a computed property, then the barGraphs computed property
// updates twice on season change.  Better for spLayer to be updated directly when season is
const spLayer = ref("TURTLE_YEAR")
const spTimeLayer = ref("TURTLE_MONTH")
const season = ref({value: "ALL", label: "All Year"})
const spGroupChoices = computed(() =>{
    const choices =[]
    for (const [key, value] of Object.entries(TurtleGroups)) {
        choices.push({value: key, label: spGroupPrettyNames[key]})
    }
    return choices
})

const activeSpCode =ref({value: "", label: ""})
const spChoices  = computed(() =>{
    const choices =[]
    TurtleGroups[activeGroup.value.value].forEach((sp) =>{
        choices.push({value: sp, label: AllCodes[sp]})
    })
    // console.log(choices)
    return choices
});


const layerType = ref({value: "density", label : "Density"})
const layerTypes = [
    {label : "Density", value: "density"}, 
    {label : "Confidence", value: "quality"}, 
]
const notSelectedTypes = computed(() =>{
    let notSel = ""
    for (const typeObj of layerTypes){
        if (typeObj.value != layerType.value.value){
            notSel += `${typeObj.label}, `
        }
    }
    return notSel.slice(0, -2);
})

const layerTypeChange = () =>{
    // console.log(mapStyleInfo)
    const spID = mapStyleInfo.value['attr']
    let attr = spID
    if(spID.endsWith("_S")){
        attr = spID.replace("_S", "")
    }
    const sp = AllCodes[attr]
    rowClick(attr, sp)
}

const clearMap = () =>{
    layerType.value = {value: "density", label : "Density"};
    monthLayerType.value = {value: "density", label : "Density"};
    clearMapStyle();
    activeSpCode.value = null;
    month.value = null;
}

const dialColors = {'color1' :'#F1FDFC', 'color2' : '#1D8177', 'color3' :'#02524a'}
const barColors ={
    "Very High" : "#830C5D",
    "High" : "#F16DC6",
    "Medium" : "#EEB3DA",
    "Low"  : "#F7E8F2",
    "No Data" : "#a1a1a1"
}

const spGroupPrettyNames ={
    "all" : "All Sea Turtles"
}

const legendColorStopNames ={
    '-9' : "No Data",
    "0" : "Low",
    "75" : "Medium", 
    "90" : "High", 
    "95" : "Very High"
}

const zDialConfig = computed(() =>{
    return {
        minVal: -2.5,   //dial min value
        maxVal: 2.5,    //dial max value
        majorTicks: 35, //this is the number of color gradations
        ticks: [-2, -1, 0, 1, 2],  //numberical label
        labels: ["Far Less", "Less", "Avg", "More", "Far More"],  //optional array of pretty names that will replace numerical.  Must be in same order
        labelSize: 10  //px size of the labels
    }
})

const columns: QTableColumn[] = [
    { name: 'name', required: true, label: 'Species', align: 'left',field: 'name', sortable: true, style: 'padding-left: 3px; width: 55px; max-width: 55px;'  },
    { name: 'Jan', align: 'center', label: 'Jan', field: 'Jan', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;'  },
    { name: 'Feb', align: 'center', label: 'Feb', field: 'Feb', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Mar', align: 'center', label: 'Mar', field: 'Mar', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Apr', align: 'center', label: 'Apr', field: 'Apr', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'May', align: 'center', label: 'May', field: 'May', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jun', align: 'center', label: 'Jun', field: 'Jun', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jul', align: 'center', label: 'Jul', field: 'Jul', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Aug', align: 'center', label: 'Aug', field: 'Aug', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Sep', align: 'center', label: 'Sep', field: 'Sep', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Oct', align: 'center', label: 'Oct', field: 'Oct', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Nov', align: 'center', label: 'Nov', field: 'Nov', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Dec', align: 'center', label: 'Dec', field: 'Dec', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
 ]
 const tableCellColors ={
    "95" : "#830C5D",
    "90" : "#F16DC6",
    "75" : "#EEB3DA",
    // "1" : "#ffffb2",
    "0"  : "#F7E8F2",
    "-9" : "#a1a1a1"
}
const barName = (i) =>{
    return "turtleBar" + i
}

const turtleTabs = ref('density')
const turtleMonthLegendTitles = computed(() =>{
    // used in the map legend-- needed so that year is updated
    // when you click on a table column
    const titles = {
        "Jan" : "density (Jan)",
        "Feb" : "density (Feb)",
        "Mar" : "density (Mar)",
        "Apr" : "density (Apr)",
        "May" : "density (May)",
        "Jun" : "density (Jun)",
        "Jul" : "density (Jul)",
        "Aug" : "density (Aug)",
        "Sep" : "density (Sep)",
        "Oct" : "density (Oct)",
        "Nov" : "density (Nov)",
        "Dec" : "density (Dec)",

    }
    return titles
})

const rowClick = (spID, sp) =>{
    activeSpCode.value = spID;
    let lyrID =activeLayerID.value
    if (layerType.value.value == 'density'){
        if (activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value.replace("_QUALITY", "")
            setDataQuality(false)
            loadDataByID(lyrID, version.value)
        }
        styleMap(lyrID, spID, 'categorical', stops['spp_95max'], legendColorStopNames) 
        setLegend(sp + ' Estimated Density (Annual max.)', stops['spp_95max'], legendColorStopNames)
    }
    else if (layerType.value.value == 'sightings'){
        if (activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value.replace("_QUALITY", "")
            setDataQuality(false)
            loadDataByID(lyrID, version.value)
        }
        const attr = spID + "_S"
        const names = {
            "1" : "Sighting",
            "0" : "No Sighting"
        }
        styleMap(lyrID, attr, 'categorical', stops['sighting'], names), 
        setLegend(sp + ' Sightings', stops['sighting'], names)
    }
    else if (layerType.value.value == 'quality'){
        if (!activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value + "_QUALITY"
            setDataQuality(true)
            loadDataByID(lyrID, version.value)
        }

        let attr = spID
        styleMap(lyrID, attr, 'categorical',  dqStops['quality_4cls'], qualityClasses)
        setLegend(sp + ': % of months with high confidence ', dqStops['quality_4cls'],  qualityClasses)
    }
    else{lyrID = activeLayerID.value}

}

const qualityClasses = {
    "-9" : "No Data",
    "1" : "Highest",
    "2" : "Medium",
    "3" : "Low",
    "4" : "Lowest"
}

// setup data for monthly data map control dropdowns & bind to table
const monthLayerType = ref({value: "density", label : "Density"})
const monthLayerTypes = [
    {label : "Density", value: "density"}, 
    {label : "Confidence", value: "quality"}, 
]

const notSelectedMonthTypes = computed(() =>{
    let notSel = ""
    for (const typeObj of monthLayerTypes){
        if (typeObj.value != monthLayerType.value.value){
            notSel += `${typeObj.label}, `
        }
    }
    return notSel.slice(0, -2);
})

const tableClickEmitFunc = (e) =>{
    // console.log(e)
    const spID = e.sp;
    month.value = arrayFindObjectByProp(months, "value", e.month)
    tableCellClick(spID, AllCodes[spID])

}

const tableCellClick = (spID, sp) =>{
    if (typeof spID === 'object'){
        activeSpCode.value= spID
    }
    else{
        activeSpCode.value = {value: spID, label: sp};
    }

    let lyrID =activeLayerID.value
    if (monthLayerType.value.value == 'density'){
        if (activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value.replace("_QUALITY", "")
            setDataQuality(false)
            loadDataByID(lyrID, version.value)
        }
        let attr = spID + "_" + month.value.value
        styleMap(lyrID, attr, 'categorical', stops['spp_95max'], legendColorStopNames) 
        setLegend(sp + " (" +month.value.label+"): Estimated Density", stops['spp_95max'], legendColorStopNames)
    }

    else if (monthLayerType.value.value == 'quality'){
        if (!activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value + "_QUALITY"
            setDataQuality(true)
            loadDataByID(lyrID, version.value)
        }
        const qualityClasses = {
            "-9" : "No Data",
            "1" : "Highest",
            "2" : "Medium",
            "3" : "Low",
            "4" : "Lowest"
        }
        let attr = spID + "_" + month.value.value
        styleMap(lyrID, attr, 'categorical',  dqStops['quality_4cls'], qualityClasses)
        setLegend(sp + " (" + month.value.label + "): Data Confidence", dqStops['quality_4cls'],  qualityClasses)
    }
    else{lyrID = activeLayerID.value}
}


const month = ref({value: "M01",  label: "Jan"})
const monthChange = (e) =>{
    // console.log(e)
    month.value = arrayFindObjectByProp(months, "value", e.value)
    tableCellClick(activeSpCode.value.value, AllCodes[activeSpCode.value.value])
}

const months = [
    {value: "M01",  label: "Jan"},
    {value: "M02",  label: "Feb"},
    {value: "M03",  label: "Mar"},
    {value: "M04",  label: "Apr"},
    {value: "M05",  label: "May"},
    {value: "M06",  label: "Jun"},
    {value: "M07",  label: "Jul"},
    {value: "M08",  label: "Aug"},
    {value: "M09",  label: "Sep"},
    {value: "M10",  label: "Oct"},
    {value: "M11",  label: "Nov"},
    {value: "M12",  label: "Dec"},
]

const getSpIDs = (data) => {
    return data.map(subArray => subArray[0].spID);
}

const infoDialogs = ref({
  turtleMonths: {
    pName: "Monthly Data",
    model: false,
    text: "Please note that monthly data is only available for a subset of turtle species."
  },
  density:{
    pName: "Estimated Density Data",
    model: false,
    text: "Estimated density values originate from NUWC Sea Turtle Distribution and Abundance models (Sparks and DiMatteo 2023). Threshold values are calculated by species across time. Yearly values are maximum values across all months. "
  },
  pHigh: {
    pName: "Percent Very High",
    model: false,
    text: "This value shows the percent of the area that is above the 'Very High' threshold (>95th percentile)"
  }
})

const dataConsiderations = ref(false)

onUnmounted(() =>{
    clearMap();
    activeSpCode.value=null;
})

onMounted(() => {
    if (activeLayerID.value != spLayer.value){
        loadDataByID(spLayer.value, version)
    }
    const mapStyle = processedData.value['mapStyle'];
    if (mapStyle) {
        const attr = mapStyle['attr'];
        const layerID = mapStyle['layerID'];

        if (layerID.includes("_QUALITY")) {
            layerType.value = { value: "quality", label: "Confidence" };
            if (!activeLayerID.value.includes("_QUALITY")) {
                const qualLayerID = `${activeLayerID.value}_QUALITY`;
                loadDataByID(qualLayerID, version);
            }
        }
        activeSpCode.value = {
            value: attr.replace("_S", ""),
            label: AllCodes[attr.replace("_S", "")]
        };
    }
})

</script>
<style scoped>


.highlight{
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
    border: 1px solid #aeaeae;
    margin: 3px;
    border-radius: 3px;
    position: relative;
    z-index: 10;
    /* margin-right: 3px; */
    /* padding-bottom:0px; */
    min-height: 12px !important; 
}
.bar-row{
    max-height: 19px;
    /* overflow: hidden; */
}
.dial-container{
    max-width: 200px;
}
.bar-rows-container{
    padding: 5px;
    max-height: 250px;
    overflow: auto;
    outline: none; /* Remove default focus outline */
}
.bar-rows-container:focus {
  outline: 2px solid #24302b; /* Add custom focus outline */
}


.mapActive{
    background-color: #1D8177;
}
.bordered{
    border: 1px solid black;
    text-align: center;
    max-height: 18px;
    vertical-align: middle;
    border-radius: 3px;
}
.time-table-container{
    max-width: 500px;
}
.tab-container{
    border-radius: 3px;
    border: 1px solid #aeaeae;
}
.secondary-dropdown{
    border: 1px solid #1D8177;
    border-radius: 5px;
    min-height:70px;
    font-size: small;
}
.map-descr-row{
    background-color: #F1FDFC;
}
.bar-row{
    max-height: 30px;
    min-height: 20px;
    /* overflow: hidden; */
}
.pointer{
    cursor: pointer;
}
</style>